import * as firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";
import "firebase/storage";

const config = {
	apiKey: "AIzaSyCrt8jtGo0U6_NjVxcmX7kem8F8ATwe-lw",
	authDomain: "ts-web-interviews.firebaseapp.com",
	databaseURL: "https://ts-web-interviews.firebaseio.com",
	projectId: "ts-web-interviews",
	storageBucket: "ts-web-interviews.appspot.com",
	messagingSenderId: "410184927349"
};

firebase.initializeApp(config);
const Fire = firebase;
export default Fire;
